module.exports = __webpack_public_path__ + "img/Icon-Send-Gift.87dbebcf.svg";